import Query from '../../../../../components/Report';

export const query = ({ prompt_uids, platforms }) => {
    return new Query('ai-tracking-keyword-google-search-urls', {
        prompt_uids: prompt_uids?.length ? setKeywordUids(prompt_uids) : '',
        platforms: platforms?.length ? setPlatforms(platforms) : '',
    });
};

function setKeywordUids(ids) {
    return `prompt_uid in (${ids.map((item) => `'${item}'`)})`;
}

function setPlatforms(platforms) {
    return `and platform in (${platforms.map((item) => `'${item}'`)})`;
}
